import MuiSwitch, { SwitchProps as MuiSwitchProps } from "@mui/material/Switch";
import MuiCheckbox, { CheckboxProps as MuiCheckboxProps } from "@mui/material/Checkbox";
import MuiRadio, { RadioProps as MuiRadioProps } from "@mui/material/Radio";
import FormControlLabel, { FormControlLabelProps } from "@mui/material/FormControlLabel";
import React from "react";

import { INDETERMINATE_VALUE } from "lib/constants";

interface SwitchProps extends MuiSwitchProps {
    labelClassName?: string;
    labelPlacement?: FormControlLabelProps["labelPlacement"];
    children: React.ReactNode;
}
export const Switch = ({
    labelPlacement = "end",
    labelClassName = "",
    children,
    ...props
}: SwitchProps) => (
    <FormControlLabel
        className={labelClassName}
        labelPlacement={labelPlacement}
        label={children}
        control={<MuiSwitch {...props}>{children}</MuiSwitch>}
    />
);

export interface CheckboxProps extends MuiCheckboxProps {
    labelClassName?: string;
    labelPlacement?: FormControlLabelProps["labelPlacement"];
    children: React.ReactNode;
}
export const Checkbox = ({
    labelPlacement = "end",
    labelClassName = "",
    checked = false,
    children,
    ...props
}: CheckboxProps) => (
    <FormControlLabel
        className={labelClassName}
        labelPlacement={labelPlacement}
        label={children}
        control={
            <MuiCheckbox
                indeterminate={checked === INDETERMINATE_VALUE}
                checked={checked !== INDETERMINATE_VALUE && checked}
                {...props}
            />
        }
    />
);

interface RadioProps extends MuiRadioProps {
    labelClassName?: string;
    labelPlacement?: FormControlLabelProps["labelPlacement"];
    children: React.ReactNode;
}
export const Radio = ({
    labelPlacement = "end",
    labelClassName = "",
    children,
    ...props
}: RadioProps) => (
    <FormControlLabel
        className={labelClassName}
        labelPlacement={labelPlacement}
        label={children}
        control={<MuiRadio {...props}>{children}</MuiRadio>}
    />
);
